import { useAngularContext } from 'AngularContext';

type IguanaUserFlags = {
    canShare?: boolean;
    blueOcean?: boolean;
    hasExternalInstitution?: boolean;
    canDownloadStreamCertificateOrAddToLinkedInProfile?: boolean;
};

/*
    The user flags this page needs that the vanilla CurrentUser does not carry.

    Each is an Iguana getter over data the vanilla user does not model:

        canShare              !hasExternalInstitution && !beta
        blueOcean             the user's only group, across groups and groupsFromInstitutions, is BLUEOCEAN
        hasExternalInstitution  a join over institutions_users
        canDownloadStreamCertificateOrAddToLinkedInProfile
                              an external-institution user, or one accepted into a degree program, or a
                              non-learner. See https://trello.com/c/h0ELD4ln.

    Rather than scatter $rootScope reads through the page, they are collected here so the exception is
    visible in one place and easy to delete once these move onto the vanilla user.
*/
export function useIguanaUserFlags(): IguanaUserFlags {
    const $injector = useAngularContext();
    const $rootScope = $injector.get<{ currentUser?: IguanaUserFlags }>('$rootScope');
    const currentUser = $rootScope.currentUser;

    return {
        canShare: currentUser?.canShare,
        blueOcean: currentUser?.blueOcean,
        hasExternalInstitution: currentUser?.hasExternalInstitution,
        canDownloadStreamCertificateOrAddToLinkedInProfile:
            currentUser?.canDownloadStreamCertificateOrAddToLinkedInProfile,
    };
}
